import restClient from "../restClient";

export const getInHouseAprs = async () => {
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await restClient.get(`in-house-aprs`, config);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const updateInHouseAprs = async ({ id, data }) => {
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await restClient.put(`in-house-aprs/${id}`, { data: data }, config);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};
